module.exports = __webpack_public_path__ + "static/zoyapaliashchuk_marketing_pr-5d9abd4289cacd95d16a5e0718a91f87.png";